import { IHesapBilgileri } from "./finance.model";

export interface IIcraBorcAlacak extends IHesapBilgileri {
    icraID: number;
    bolumID: number;
    blokID: number;
}

export interface IIcraBorcAlacakBlok {
    blokID: number;
    blokNo: string;
}

export interface IIcraBorcAlacakBolum {
    blokID: number;
    bolumID: number;
    bolumNo: string;
}

export class IcraBorcAlacakFilter {
    adiSoyadi: string;
    blokID: number;
    bolumID: number;
    durum: boolean;
}